import { lightTheme } from "./themes";
import type { Theme } from "./themes";

/** The name of a colour in a theme. */
export type ColorName = keyof Theme;

/** The CSS variable that holds a colour of the current theme, like `--color-accent-soft`. */
export function cssVariable(name: ColorName): string {
    return `--color-${name.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)}`;
}

/** The colours of the current theme, to use in styles: `color: ${color.text};`. */
export const color = Object.fromEntries(
    (Object.keys(lightTheme) as ColorName[]).map((name) => [name, `var(${cssVariable(name)})`]),
) as Record<ColorName, string>;
